import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { KeycloakInitStatusService } from './shared/services/keycloak-init-status.service';
import { LoadIotaConfig } from './store/actions/iota-config.actions';
import { LoadUser } from './store/actions/user.actions';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'iota-web-management-portal-v4';
    readonly loginUnavailable = this.keycloakInitStatus.failed;

    constructor(
        private store: Store,
        private keycloakInitStatus: KeycloakInitStatusService
    ) {}

    ngOnInit(): void {
        if (this.loginUnavailable()) {
            return;
        }
        this.store.dispatch(LoadIotaConfig());
        // Keycloak is initialised and authenticated before bootstrap.
        this.store.dispatch(LoadUser());
    }

    reload(): void {
        window.location.reload();
    }
}
